<template>
  <div>
    <v-dialog
      v-if="
        isPermitted(PermissionEnum.DEVICES.ADD) ||
          isPermitted(PermissionEnum.DEVICES.UPDATE)
      "
      v-model="importDialog"
      max-width="500px"
      persistent
      id="devices__import-dialog"
    >
      <v-card>
        <v-form
          v-model="valid"
          ref="devicesImportForm"
          @submit.prevent="submit()"
          enctype="multipart/form-data"
        >
          <v-card-title>
            <span class="headline" id="devices__form-import-title">
              {{ $t("modules.devices.import") }}
            </span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md v-if="!isSubmitted && !isSuccess">
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-file-input
                    v-model="devicesCSV"
                    :label="$t('modules.devices.devicesCSV')"
                    id="devices__form-devices"
                    accept=".csv"
                    :rules="devicesCSVRules"
                  ></v-file-input>
                </v-flex>
              </v-layout>
            </v-container>
            <div class="text-center" v-else-if="isSubmitted && !isSuccess">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="40"
              ></v-progress-circular>
              <div class="title grey--text">
                {{ $t("modules.devices.importMessage") }}
              </div>
            </div>
            <div v-else class="text-center">
              <v-icon size="60">mdi-check-all</v-icon>
              <div class="primary--text title">
                {{ $t("modules.devices.addedDevices", [added]) }}
              </div>
              <div class="red--text title">
                {{ $t("modules.devices.failedDevices", [failed]) }}
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              v-if="!isSubmitted || isSuccess"
              elevation="1"
              @click="close"
              id="devices__cancel"
              >{{ $t("actions.close") }}</v-btn
            >
            <v-btn
              color="secondary"
              text
              v-if="!isSuccess"
              elevation="1"
              type="submit"
              :loading="is_loading"
              :disabled="is_loading_global"
              id="devices__save"
              >{{ $t("actions.submit") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { handleError } from "@/utils/error";
import { permissionMixin } from "@/mixins/permissions";

export default {
  name: "DevicesImport",
  mixins: [permissionMixin],
  data() {
    return {
      valid: false,
      isSubmitted: false,
      isSuccess: false,
      devicesCSV: null,
      added: 0,
      failed: 0,
      devicesCSVRules: [
        v =>
          !!v ||
          this.$t("validation.required", [
            this.$t("modules.devices.devicesCSV")
          ]),
        v =>
          !v ||
          ["csv"].indexOf(
            v.name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1 ||
          this.$t("modules.devices.invalidFileType")
      ]
    };
  },
  computed: {
    importDialog: {
      get() {
        return this.$store.state.devices.importDialog;
      },
      set(val) {
        this.$store.dispatch("devices/updateImportDialog", val);
      }
    },
    is_loading() {
      return this.$store.state.loader.is_loading;
    },
    is_loading_global() {
      return this.$store.state.loader.is_loading_global;
    }
  },

  methods: {
    submit() {
      if (this.$refs.devicesImportForm.validate()) {
        this.isSubmitted = true;
        this.$store.dispatch("loader/startLoading");
        let formData = new FormData();
        formData.append("devices", this.devicesCSV);
        this.$store
          .dispatch("devices/importDevices", formData)
          .then(response => {
            this.added = response.data.ids.length || 0;
            this.failed = response.data.failed;
            this.isSuccess = true;
            this.devicesCSV = null;
            this.$store.dispatch("devices/fetchAll");
          })
          .catch(error => {
            this.isSubmitted = false;
            handleError(error);
          });
        this.$refs.devicesImportForm.resetValidation();
      }
    },

    close() {
      this.isSuccess = false;
      this.isSubmitted = false;
      this.devicesCSV = null;
      this.$refs.devicesImportForm.resetValidation();
      this.$store.commit("devices/updateImportDialog", false);
    }
  }
};
</script>

<style></style>
